export default {
  formatPhoneNumber: (number) => number.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
};



// WEBPACK FOOTER //
// ./webpack/lib/utils/phone.js